import { Injectable } from '@angular/core';
import { ISignatureDataFormatterService } from '../../interfaces/ISignatureDataFormatterService';

@Injectable({
  providedIn: 'root',
})
export class BullhornSignatureFormatterService implements ISignatureDataFormatterService {
  public formatDataPath(fieldType: string, dataPath: string): string {
    const formattedDataPath = this.formatForType(fieldType, dataPath);
    return this.wrapExpression(formattedDataPath);
  }

  private formatForType(fieldType: string, dataPath: string) {
    switch (fieldType) {
      case 'date':
        return this.dateExpression(dataPath, 'MM/dd/yyyy');
      default:
        return dataPath;
    }
  }

  private wrapExpression(expression: string) {
    return `[(\${${expression}})]`;
  }

  private dateExpression(dataPath: string, dateFormat: string) {
    return `#temporals.format(${dataPath}, \'${dateFormat}\')`;
  }
}
